import React, { Component } from "react";
import { observer } from "mobx-react";
import PricingGrid from "./PricingGrid";
import { PricingPayload } from "../../../../stores/PricingStore/Types";

interface Props {
  handleShowSignInSideBar: (redirectUrl?: string) => void;
  pricing: PricingPayload;
  showSigninSidebar: boolean;
  courseSlug?: string;
  singleCourseHeading?: string;
  updateStyle?: boolean;
  isCoursePricing?: boolean;
}

// The pricing section on the home page and on every course page. The
// /pricing page composes its own from the older cards.
class NewPricing extends Component<Props, {}> {
  render() {
    const { pricing, courseSlug, singleCourseHeading, updateStyle, isCoursePricing } =
      this.props;

    if (pricing.kind !== "pricing") return <div className="no-pricing" />;

    return (
      <PricingGrid
        pricing={pricing}
        page={isCoursePricing ? "course" : "home"}
        courseName={isCoursePricing ? singleCourseHeading : undefined}
        courseSlug={courseSlug}
        compact={updateStyle}
      />
    );
  }
}

export default observer(NewPricing);
